import {Home} from "react-feather";
import {SideBarItem} from "interfaces";
import {Fragment} from "react/jsx-runtime";
import {
  PeopleOutlined,
  PaymentOutlined,
  AccountBalanceOutlined,
} from "@mui/icons-material";

export const sidebar: SideBarItem[] = [
  {
    module: {
      label: "Navegación",
      icon: <Fragment />,
    },
    routes: [
      {
        path: "/resume",
        icon: Home,
        label: "Inicio",
      },
      {
        icon: PeopleOutlined,
        label: "Clientes",
        path: "/clients",
      },
      {
        icon: AccountBalanceOutlined,
        path: "/credits",
        label: "Créditos",
      },
      {
        icon: PaymentOutlined,
        path: "/payments",
        label: "Pagos",
      },
    ],
  },
];
